import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store";
import { getDefaultHomePage } from "../../common/util/Navigation/navigationUtil";
import { ERROR_ROUTE_SUBPATHS, getFullRoutePath } from "../../routing/ErrorRoutes";

export const HomePage = () => {
  const { configuration, user, isShellLoading } = useAppSelector((state) => state.boot);

  const navigate = useNavigate();

  useEffect(() => {
    if (isShellLoading) return;

    if (user && user.abo && user.aff && user.access_token) {
      navigate(getDefaultHomePage(configuration.cppModHomePage));
    } else {
      navigate(getFullRoutePath(ERROR_ROUTE_SUBPATHS.AUTHENTICATION_FAILED));
    }
  }, [configuration, isShellLoading, navigate, user]);

  return <></>;
};
